import bloomify from '@mediashop/app/bloomreach/bloomify';
import CustomerClubComponent from '../pattern/molecule/CustomerClub';

const CustomerClub = (props) => <CustomerClubComponent {...props} />;

export default bloomify(CustomerClub, { className: 'br-component__account-content' });
